import * as z from "zod";

export const deleteCampaign = {
  name: "deleteCampaign" as const,
  input: z.object({ id: z.string() }),
  output: z.null(),
};
